import BaseComponent from "../../../../baseComponent.js";

export default class FontSizeTypeOption extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      type: props.type
    }
  }

  onOptionValueClick(type) {
    this.props.onOptionValueClick(type);
    this.setState({type});
  }

  componentWillReceiveProps(nextProps) {
    this.setState({type: nextProps.type});
  }

  showOptions(ref) {
    let element = this.refs[ref];
    this.props.onOptionClick(element);
  }

  render() {
    return (
      <div>
        <div className='tw-option-container'>
          <div className='t-col single' data-cat='precision' ref="type"
               onClick={() => this.showOptions("typeOptions")} style={{textAlign: 'left', padding: '0 10px'}}>
            Font Size Type: {this.state.type === "Absolute" ? "Fixed" : "Relative"}
          </div>
        </div>
        <div className='option-list length' ref="typeOptions"
             style={{width: '168px', height: '74px', overflowY: 'auto'}}>
          <div className="item" onClick={() => this.onOptionValueClick('Relative')}>Relative</div>
          <div className="item" onClick={() => this.onOptionValueClick('Absolute')}>Fixed</div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/textual/style/fontSizeTypeOption.jsx